export const haptics = {
  select: () => {},
  success: () => {},
};
